(() => {
  'use strict';
  const init = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.initialized) return;
      let data;
      try { data = JSON.parse(section.querySelector('[data-variant-data]').textContent); }
      catch { return; } // The native variant form remains usable if enhancement fails.
      const form = section.querySelector('.product-form');
      const select = form.querySelector('[data-variant-select]');
      const fields = [...form.querySelectorAll('[data-option-index]')];
      const button = form.querySelector('[data-add-button]');
      const message = form.querySelector('[data-product-message]');
      const purchasing = section.dataset.purchasing === 'true';
      const thumbs = [...section.querySelectorAll('[data-show-media]')];
      const media = [...section.querySelectorAll('.gallery-media')];
      function showMedia(id) {
        if (!id || !media.some((item) => item.dataset.mediaId === String(id))) return;
        media.forEach((item) => {
          item.hidden = item.dataset.mediaId !== String(id);
          if (item.hidden) item.querySelectorAll('video').forEach((video) => video.pause());
        });
        thumbs.forEach((thumb) => {
          const active = thumb.dataset.showMedia === String(id);
          thumb.classList.toggle('active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
      }
      function updateGallery(options, variant) {
        const colorIndex = fields.findIndex((field) => /^(colou?r|garment colou?r)$/i.test(field.dataset.optionName));
        const color = options[colorIndex];
        const matches = color ? thumbs.filter((thumb) => thumb.dataset.mediaAlt.includes(' — ' + color + ' — ')) : [];
        thumbs.forEach((thumb) => { thumb.hidden = matches.length > 0 && !matches.includes(thumb); });
        const back = matches.find((thumb) => thumb.dataset.mediaAlt.endsWith(' — Back'));
        const colorVariant = variant || data.variants.find((candidate) => candidate.mediaId && colorIndex >= 0 && candidate.options[colorIndex] === color);
        showMedia(back?.dataset.showMedia || colorVariant?.mediaId || matches[0]?.dataset.showMedia);
      }
      function sync() {
        const selected = fields.map((field) => field.querySelector('input:checked')?.value ?? null);
        const variant = data.variants.find((candidate) => candidate.options.every((option, index) => selected[index] === option));
        select.value = variant ? String(variant.id) : '';
        fields.forEach((field, index) => {
          field.querySelector('[data-option-label]').textContent = selected[index] || '';
          if (/^size$/i.test(field.dataset.optionName)) {
            field.querySelectorAll('input').forEach((radio) => {
              const available = data.variants.some((candidate) => candidate.available && candidate.options.every((option, i) => i === index ? option === radio.value : !selected[i] || option === selected[i]));
              radio.disabled = !available;
              radio.closest('label').title = available ? '' : 'Unavailable in this colour';
            });
          }
        });
        const complete = selected.every((option) => option !== null);
        const canAdd = purchasing && variant?.available && complete;
        button.disabled = !canAdd;
        button.textContent = !purchasing ? 'Coming soon' : !complete ? 'Choose your size' : !variant ? 'Unavailable' : !variant.available ? 'Sold out' : 'Add to bag';
        message.textContent = purchasing && complete && !variant?.available ? 'This combination is unavailable. Choose another size or colour.' : '';
        const priceVariant = variant || data.variants.find((candidate) => candidate.options.every((option, i) => !selected[i] || option === selected[i]));
        if (priceVariant) {
          section.querySelector('[data-product-price]').textContent = priceVariant.price;
          const compare = section.querySelector('[data-compare-price]');
          compare.textContent = priceVariant.comparePrice || '';
          compare.hidden = !priceVariant.comparePrice;
        }
        updateGallery(selected, variant);
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant', variant.id);
        else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
      if (data.selectedId) {
        const selectedVariant = data.variants.find((variant) => variant.id === data.selectedId);
        if (selectedVariant) fields.forEach((field, index) => field.querySelectorAll('input').forEach((input) => { input.checked = input.value === selectedVariant.options[index]; }));
      }
      // A simple product with no options can be ordered without a size picker.
      if (fields.length === 1 && fields[0].dataset.optionName === 'Title') {
        fields[0].querySelector('input').checked = true;
        fields[0].hidden = true;
      }
      fields.forEach((field) => field.addEventListener('change', sync));
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.showMedia)));
      form.addEventListener('submit', (event) => {
        const variant = data.variants.find((item) => String(item.id) === select.value);
        if (!purchasing || !variant?.available || !form.checkValidity()) {
          event.preventDefault();
          message.textContent = 'Please choose an available colour and size.';
          form.reportValidity();
        }
      });
      form.querySelector('[data-native-variants]').hidden = true;
      form.querySelector('[data-enhanced-options]').hidden = false;
      select.required = false;
      section.dataset.initialized = 'true';
      sync();
    });
    root.querySelectorAll('[data-quantity-step]').forEach((button) => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input[type="number"]');
        if (!input) return;
        const min = Number(input.min || 0);
        const max = input.max ? Number(input.max) : Number.MAX_SAFE_INTEGER;
        const current = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : min;
        input.value = String(Math.max(min, Math.min(max, current + Number(button.dataset.quantityStep))));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    const cart = root.querySelector('#CartForm');
    if (cart && !cart.dataset.initialized) {
      cart.dataset.initialized = 'true';
      cart.addEventListener('change', () => {
        cart.querySelector('[data-cart-status]').textContent = 'Select Update bag to refresh your subtotal.';
      });
    }
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-navigation[open], .nav-dropdown[open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.mobile-navigation[open], .nav-dropdown[open]').forEach((details) => {
      if (!details.contains(event.target) || event.target.closest('a')) details.open = false;
    });
  });
})();
